<template>
  <div class="dep-staff">
    <info-block :title="$t('employees.page_name')"
                marker-color="#FAD977"
                :footer-text="date"
                >
      <pagination :documents-name="$t('labels.employees1')"
                :count="userList.length"
                :pagination="pagination"
                @size-change="onPaginationPageSizeChange"
                @current-change="onPaginationCurrentChange"></pagination>
        <user-table
        :emptyText="$t('labels.not_founded')"
        :loadingUsers="loadingUsers"
        :data="userList"
        @sort-change="onSortChange"
        @row-click="onTableRowClick"
        :default-sort="order"
        :index-offset="pagination.pageSize * (pagination.currentPage - 1)"
        short-mode
        :showExpand="false"
        :sortable="false"
      ></user-table>
      <pagination :count="count"
                  :pagination="pagination"
                  @size-change="onPaginationPageSizeChange"
                  @current-change="onPaginationCurrentChange"></pagination>
    </info-block>
  </div>
</template>
<script>
  import userList from 'src/components/Users/UserList/List.vue';
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
  import UserTable from 'src/components/Users/UserList/UserTable.vue'
  import Pagination from 'src/components/Ui/Pagination/Pagination';

  export default {
    components: {
      userList,
      infoBlock
    },
    props: ['orgId', 'date'],
    components: {
      UserTable,
      Pagination
    },
    data () {
      return {
        loadingUsers: false,
        userList: [],
        count: null,
        order: {
          prop: 'last_name',
          order: 'ascending'
        },
        filters: {
          workStatus: [
            {
              value: 'active',
              label: this.$t('employees.work_status.active')
            }, {
              value: 'closed',
              label: this.$t('employees.work_status.closed')
            }
          ],
          onlineStatus: [
            {
              value: 'online',
              label: 'Online'
            }, {
              value: 'offline',
              label: 'Offline'
            }
          ]
        },
        pagination: {
          pageSize: 10,
          currentPage: 1,
          totalItems: 10
        },
        columnNames: ['№', this.$t('labels.surname'), this.$t('labels.name'), this.$t('labels.middle_name'), this.$t('labels.position'), this.$t('labels.cols.status'), this.$t('labels.last_activity')]
      }
    },
    methods: {
      async loadList(query, filter, order) {
        this.loadingUsers = true
        try {
          let response = await this.$store.dispatch('users/findUsers',
            {
              limit: this.pagination.pageSize,
              offset: this.pagination.pageSize * (this.pagination.currentPage - 1),
              orgs: [this.orgId]
            });
          this.loadingUsers = false
          console.log('LOG: loadList -> users', response)
          this.userList = response.users;
          this.count = response.count;
          this.pagination.totalItems = response.count;
          /* let response = await this.$store.dispatch('users/getUsersByOrg', {
            org_id: this.orgId,
            limit: this.pagination.pageSize,
            offset: this.pagination.pageSize * (this.pagination.currentPage - 1),
            withPasrot: false
          }) */

          // this.count = data.count;
          // this.pagination.totalItems = data.count;
          // this.userList = data.result;
          // result = data;
        } catch (resp) {
          console.log(resp)
          this.$notify({
            // @ts-ignore
            title: this.$t('labels.error'),
            // @ts-ignore
            message: this.$t('labels.can_not_load_users'),
            type: 'error',
            offset: 75,
            duration: 2000
          });
        }
        this.loadingUsers = false
        // return result
      },
      onSortChange(event) {
        if (event.column) {
          this.order.prop = event.column.property
          this.order.order = event.order
        } else {
          this.order = {}
        }
        // this.search()
      },
      onTableRowClick(row, event, column) {
        if (this.columnNames.indexOf(column.label) > 0) {
          this.$router.push({name: 'user', params: {id: row.id}});
        }
      },
      onPaginationPageSizeChange(size) {
        this.pagination.currentPage = 1
        this.pagination.pageSize = size;
        // this.search();
      },
      onPaginationCurrentChange(currentPage) {
        this.pagination.currentPage = currentPage;
        // this.search();
      }
    },
    computed: {
      user () {
        return this.$store.state.users.user
      }
    },
    async mounted() {
      await this.loadList();
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.dep-staff {
  .user-list-table {
    margin: -15px -30px 0 -30px;
  }

  .pagination {
    margin: 20px -30px;
    padding: 10px 30px;
    align-items: center;
  }

  .user-list-table .el-table th:first-child .cell {
    padding-left: 30px;
  }

  .user-list-table .el-table__row td:first-child {
    padding-left: 30px;
  }

  .pagination {
    padding: 0 30px;
  }
}
</style>